import { ref } from 'vue-demi';
import { useCurrentAccount } from '@teamwork/use';
import {
  EXP_32_CUSTOMERS,
  EXP_32_TRIALS,
} from '@/platform/components/side-nav/panels/help-center/constants';
import { useFeatures } from '@/platform/composables/useFeatures';
import { usePreferences } from '@/platform/composables/usePreferences';

export default function useHelpCenter() {
  const { newSidebarNavigationEnabled } = useFeatures();
  const { shouldShowRedesignedSidebar } = usePreferences();
  const account = useCurrentAccount();

  const experimentFlagKey = ref(EXP_32_TRIALS);

  if (
    account.value?.paymentStatus &&
    account.value.paymentStatus !== 'trial' &&
    (shouldShowRedesignedSidebar.value || newSidebarNavigationEnabled.value)
  ) {
    experimentFlagKey.value = EXP_32_CUSTOMERS;
  }

  return {
    experimentFlagKey,
  };
}
